import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import { Currency, Tooltip } from 'react-wot-bootstrap'

import { CURRENCIES } from 'helpers/i18n'

import {
    EARN_RESOURCES_ON_GLOBAL_MAP,
    NOW_IN_TREASURY,
} from './constants'

import styles from './CurrencyTooltip.scss'

export class CurrencyTooltip extends React.PureComponent {
    static propTypes = {
        amount: PropTypes.number.isRequired,
        type: PropTypes.oneOf(Object.values(Currency.TYPES)).isRequired,
    }
    static base_id = 'clan_panel_currency_tooltip'

    render() {
        return (
            <Tooltip id={`${CurrencyTooltip.base_id}_${this.props.type}`}>
                <div className={styles.content}>
                    <p className={styles.subtitle}>
                        {CURRENCIES[this.props.type]}
                    </p>
                    <div className={styles.message}>
                        {NOW_IN_TREASURY}&nbsp;
                        <Currency
                            small
                            iconPosition='after'
                            type={this.props.type}
                            value={<FormattedNumber value={this.props.amount} />}
                        />
                    </div>
                    <span className={styles.divider} />
                    <p className={styles.message}>
                        {EARN_RESOURCES_ON_GLOBAL_MAP[this.props.type]}
                    </p>
                </div>
            </Tooltip>
        )
    }
}

export default CurrencyTooltip



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/CurrencyTooltip/CurrencyTooltip.jsx